export default __webpack_public_path__ + "static/media/technolog.4b3db553.pdf";